import { useState, useEffect } from "react";  
import { useSelector, useDispatch } from 'react-redux';
import { getCursos } from '../redux/features/cursosSlice';

const useCourses = () => {

  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(getCursos());
  }, []);

  const [allCourses, setAllCourses] = useState(useSelector(state => state.cursosSlice.data));
  
  return {
    allCourses,
    setAllCourses,
  }

}

export default useCourses;